
/* injects from baggage-loader */

'use strict';

/**
 * Constants to use in the cashier search module.
 */
const cashierSearchConstant = {
	CASHIER_LABEL: 'Cajero',
	NOT_FOUND_CASHIERS: 'No se pudieron adquirir los cajeros'
};

export default cashierSearchConstant;



// WEBPACK FOOTER //
// ./src/app/core/components/cashierSearch/cashierSearch.constant.js